/**
 * [sc-48351] Dove porta un indirizzo su Google Maps.
 *
 * Il link preciso lo costruisce l'API, da coordinate e `placeId`, solo quando
 * l'indirizzo è stato scelto fra i suggerimenti di Google. Uno scritto a mano
 * non ce l'ha: allora si cerca il testo su Maps, meno preciso ma quasi sempre
 * nel posto giusto. Senza indirizzo non c'è link.
 *
 * @param {{link?: string, address?: string}} [sede]
 * @returns {string} l'indirizzo della pagina di Maps, o ""
 */
export function linkMaps(sede) {
  const link = String(sede?.link || "").trim();
  if (link) return link;
  const indirizzo = String(sede?.address || "").trim();
  if (!indirizzo) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    indirizzo
  )}`;
}
